import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

export const CaseButton = ({ caseUrl, children, className }) => {
  const extrernalLink =
    !caseUrl.includes("beaversbrothers.ru") &&
    !caseUrl.includes("beaversbrothers.com") &&
    !caseUrl.includes("dabb.pro")

  if (extrernalLink) {
    return (
      <a
        className={cn(className, styles.Button)}
        href={caseUrl}
        rel="noopener noreferrer"
        target={"_blank"}
      >
        {children}
      </a>
    )
  }

  return (
    <a className={cn(className, styles.Button)} href={caseUrl}>
      {children}
    </a>
  )
}
